import styled from 'styled-components'

// Changed from width: 100%; to left/right positioning to avoid covering the scrollbar.
export const AnchorAdWrapper = styled.div`
  position: fixed;
  /* background-color: var(--content-background-light); */
  bottom: 0;
  left: 0;
  right: 14px; /* Leaves room for scrollbar */
  background: white;
  text-align: center;
  z-index: 999;
  @media (max-width: 768px) {
    right: 4px;
  }
`

export const AnchorAdContent = styled.div`
  width: 100%;
  /* This is where the ad loads; no id styling interference */
`

export const AnchorCloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 12px; /* bumped left by 12px so it doesn't overlap scrollbar */
  padding: 5px 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #000;
  &:hover {
    color: var(--highlight-blue);
  }
  @media (max-width: 768px) {
    right: 0;
    padding: 0;
    font-size: 12px;
  }
`
